//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL_POS = new InjectionToken<string>('API_BASE_URL_POS');

export interface IArticlesClient {
    getArticles(): Observable<ResultOfIEnumerableOfFiskalniArtikalInfoDto>;
    getAvansArticles(): Observable<ResultOfIEnumerableOfFiskalniArtikalInfoDto>;
    createArticle(request: CreateArticleCommand): Observable<ResultOfArticleInfoResponse>;
    updateArticle(request: UpdateArticleCommand): Observable<ResultOfArticleInfoResponse>;
    getWarehous(): Observable<ResultOfIEnumerableOfMagacinDto>;
    createGroup(naziv?: string | null | undefined): Observable<ResultOfLong>;
    updateGroup(naziv?: string | null | undefined, oznakaId?: number | undefined): Observable<ResultOfString>;
    getGroups(): Observable<ResultOfIEnumerableOfGroupDto>;
    getUnitMeasures(): Observable<ResultOfIEnumerableOfUnitMeasureDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ArticlesClient implements IArticlesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_POS) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getArticles(): Observable<ResultOfIEnumerableOfFiskalniArtikalInfoDto> {
        let url_ = this.baseUrl + "/api/pos/articles/get-articles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArticles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIEnumerableOfFiskalniArtikalInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIEnumerableOfFiskalniArtikalInfoDto>;
        }));
    }

    protected processGetArticles(response: HttpResponseBase): Observable<ResultOfIEnumerableOfFiskalniArtikalInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIEnumerableOfFiskalniArtikalInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIEnumerableOfFiskalniArtikalInfoDto>(null as any);
    }

    getAvansArticles(): Observable<ResultOfIEnumerableOfFiskalniArtikalInfoDto> {
        let url_ = this.baseUrl + "/api/pos/articles/get-avans-articles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvansArticles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvansArticles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIEnumerableOfFiskalniArtikalInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIEnumerableOfFiskalniArtikalInfoDto>;
        }));
    }

    protected processGetAvansArticles(response: HttpResponseBase): Observable<ResultOfIEnumerableOfFiskalniArtikalInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIEnumerableOfFiskalniArtikalInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIEnumerableOfFiskalniArtikalInfoDto>(null as any);
    }

    createArticle(request: CreateArticleCommand): Observable<ResultOfArticleInfoResponse> {
        let url_ = this.baseUrl + "/api/pos/articles/create-article";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateArticle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateArticle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfArticleInfoResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfArticleInfoResponse>;
        }));
    }

    protected processCreateArticle(response: HttpResponseBase): Observable<ResultOfArticleInfoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfArticleInfoResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfArticleInfoResponse>(null as any);
    }

    updateArticle(request: UpdateArticleCommand): Observable<ResultOfArticleInfoResponse> {
        let url_ = this.baseUrl + "/api/pos/articles/update-article";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateArticle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateArticle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfArticleInfoResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfArticleInfoResponse>;
        }));
    }

    protected processUpdateArticle(response: HttpResponseBase): Observable<ResultOfArticleInfoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfArticleInfoResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfArticleInfoResponse>(null as any);
    }

    getWarehous(): Observable<ResultOfIEnumerableOfMagacinDto> {
        let url_ = this.baseUrl + "/api/pos/articles/get-warehouse";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWarehous(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWarehous(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIEnumerableOfMagacinDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIEnumerableOfMagacinDto>;
        }));
    }

    protected processGetWarehous(response: HttpResponseBase): Observable<ResultOfIEnumerableOfMagacinDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIEnumerableOfMagacinDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIEnumerableOfMagacinDto>(null as any);
    }

    createGroup(naziv?: string | null | undefined): Observable<ResultOfLong> {
        let url_ = this.baseUrl + "/api/pos/articles/create-group?";
        if (naziv !== undefined && naziv !== null)
            url_ += "naziv=" + encodeURIComponent("" + naziv) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfLong>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfLong>;
        }));
    }

    protected processCreateGroup(response: HttpResponseBase): Observable<ResultOfLong> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfLong.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfLong>(null as any);
    }

    updateGroup(naziv?: string | null | undefined, oznakaId?: number | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pos/articles/update-group?";
        if (naziv !== undefined && naziv !== null)
            url_ += "naziv=" + encodeURIComponent("" + naziv) + "&";
        if (oznakaId === null)
            throw new Error("The parameter 'oznakaId' cannot be null.");
        else if (oznakaId !== undefined)
            url_ += "oznakaId=" + encodeURIComponent("" + oznakaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUpdateGroup(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getGroups(): Observable<ResultOfIEnumerableOfGroupDto> {
        let url_ = this.baseUrl + "/api/pos/articles/get-groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIEnumerableOfGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIEnumerableOfGroupDto>;
        }));
    }

    protected processGetGroups(response: HttpResponseBase): Observable<ResultOfIEnumerableOfGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIEnumerableOfGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIEnumerableOfGroupDto>(null as any);
    }

    getUnitMeasures(): Observable<ResultOfIEnumerableOfUnitMeasureDto> {
        let url_ = this.baseUrl + "/api/pos/articles/get-unit-measures";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnitMeasures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnitMeasures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIEnumerableOfUnitMeasureDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIEnumerableOfUnitMeasureDto>;
        }));
    }

    protected processGetUnitMeasures(response: HttpResponseBase): Observable<ResultOfIEnumerableOfUnitMeasureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIEnumerableOfUnitMeasureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIEnumerableOfUnitMeasureDto>(null as any);
    }
}

export interface ICertificatesClient {
    downloadSertifikat(): Observable<FileResponse>;
    getCertificateInfo(): Observable<ResultOfCertificateInfoResponse>;
    getSertifikatiFiskalneKaseDropdown(): Observable<ResultOfListOfSertifikatFiskalneKaseDto>;
}

@Injectable({
    providedIn: 'root'
})
export class CertificatesClient implements ICertificatesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_POS) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    downloadSertifikat(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/pos/certificates/download";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadSertifikat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadSertifikat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadSertifikat(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getCertificateInfo(): Observable<ResultOfCertificateInfoResponse> {
        let url_ = this.baseUrl + "/api/pos/certificates/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificateInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificateInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfCertificateInfoResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfCertificateInfoResponse>;
        }));
    }

    protected processGetCertificateInfo(response: HttpResponseBase): Observable<ResultOfCertificateInfoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfCertificateInfoResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfCertificateInfoResponse>(null as any);
    }

    getSertifikatiFiskalneKaseDropdown(): Observable<ResultOfListOfSertifikatFiskalneKaseDto> {
        let url_ = this.baseUrl + "/api/pos/certificates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSertifikatiFiskalneKaseDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSertifikatiFiskalneKaseDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfListOfSertifikatFiskalneKaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfListOfSertifikatFiskalneKaseDto>;
        }));
    }

    protected processGetSertifikatiFiskalneKaseDropdown(response: HttpResponseBase): Observable<ResultOfListOfSertifikatFiskalneKaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfListOfSertifikatFiskalneKaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfListOfSertifikatFiskalneKaseDto>(null as any);
    }
}

export interface ICompaniesClient {
    getCompany(): Observable<ResultOfCompanyDto>;
}

@Injectable({
    providedIn: 'root'
})
export class CompaniesClient implements ICompaniesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_POS) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getCompany(): Observable<ResultOfCompanyDto> {
        let url_ = this.baseUrl + "/api/pos/companies/get-company";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfCompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfCompanyDto>;
        }));
    }

    protected processGetCompany(response: HttpResponseBase): Observable<ResultOfCompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfCompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfCompanyDto>(null as any);
    }
}

export interface ICustomersClient {
    getAllUsers(request: GetAllCustomersQuery): Observable<ResultOfIEnumerableOfStrankaPosDto>;
}

@Injectable({
    providedIn: 'root'
})
export class CustomersClient implements ICustomersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_POS) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAllUsers(request: GetAllCustomersQuery): Observable<ResultOfIEnumerableOfStrankaPosDto> {
        let url_ = this.baseUrl + "/api/pos/customers/get-all-customers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfIEnumerableOfStrankaPosDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfIEnumerableOfStrankaPosDto>;
        }));
    }

    protected processGetAllUsers(response: HttpResponseBase): Observable<ResultOfIEnumerableOfStrankaPosDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfIEnumerableOfStrankaPosDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfIEnumerableOfStrankaPosDto>(null as any);
    }
}

export interface IInitClient {
    initBezbednosniElement(request: CreateBezbednosniElementLPFRCommand): Observable<ResultOfGetAllUsersResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class InitClient implements IInitClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_POS) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    initBezbednosniElement(request: CreateBezbednosniElementLPFRCommand): Observable<ResultOfGetAllUsersResponse> {
        let url_ = this.baseUrl + "/api/pos/init/init-bezbednosni-element";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInitBezbednosniElement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInitBezbednosniElement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetAllUsersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetAllUsersResponse>;
        }));
    }

    protected processInitBezbednosniElement(response: HttpResponseBase): Observable<ResultOfGetAllUsersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetAllUsersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetAllUsersResponse>(null as any);
    }
}

export interface IInvoicesClient {
    saveInvoice(request: SaveInvoiceCommand): Observable<ResultOfString>;
    uploadFisakalnogIsecka(id: number, file?: FileParameter | null | undefined, invoiceResponseId?: number | undefined): Observable<ResultOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class InvoicesClient implements IInvoicesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_POS) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    saveInvoice(request: SaveInvoiceCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pos/invoices/save-invoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSaveInvoice(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    uploadFisakalnogIsecka(id: number, file?: FileParameter | null | undefined, invoiceResponseId?: number | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pos/invoices/upload-fiskalni-isecak/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (invoiceResponseId === null || invoiceResponseId === undefined)
            throw new Error("The parameter 'invoiceResponseId' cannot be null.");
        else
            content_.append("InvoiceResponseId", invoiceResponseId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFisakalnogIsecka(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFisakalnogIsecka(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processUploadFisakalnogIsecka(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }
}

export interface IIzvestajiClient {
    getIzvestaj(datum?: Date | null | undefined, datumOd?: Date | null | undefined, datumDo?: Date | null | undefined, kasirId?: string | null | undefined, jeOnlineProdaja?: boolean | undefined): Observable<ResultOfMaloprodajaIzvestajDto>;
    getKasire(): Observable<ResultOfGetKasiriZaIzvestajResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class IzvestajiClient implements IIzvestajiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_POS) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getIzvestaj(datum?: Date | null | undefined, datumOd?: Date | null | undefined, datumDo?: Date | null | undefined, kasirId?: string | null | undefined, jeOnlineProdaja?: boolean | undefined): Observable<ResultOfMaloprodajaIzvestajDto> {
        let url_ = this.baseUrl + "/api/pos/izvestaji/get-izvestaj?";
        if (datum !== undefined && datum !== null)
            url_ += "datum=" + encodeURIComponent(datum ? "" + datum.toISOString() : "") + "&";
        if (datumOd !== undefined && datumOd !== null)
            url_ += "datumOd=" + encodeURIComponent(datumOd ? "" + datumOd.toISOString() : "") + "&";
        if (datumDo !== undefined && datumDo !== null)
            url_ += "datumDo=" + encodeURIComponent(datumDo ? "" + datumDo.toISOString() : "") + "&";
        if (kasirId !== undefined && kasirId !== null)
            url_ += "kasirId=" + encodeURIComponent("" + kasirId) + "&";
        if (jeOnlineProdaja === null)
            throw new Error("The parameter 'jeOnlineProdaja' cannot be null.");
        else if (jeOnlineProdaja !== undefined)
            url_ += "jeOnlineProdaja=" + encodeURIComponent("" + jeOnlineProdaja) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIzvestaj(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIzvestaj(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfMaloprodajaIzvestajDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfMaloprodajaIzvestajDto>;
        }));
    }

    protected processGetIzvestaj(response: HttpResponseBase): Observable<ResultOfMaloprodajaIzvestajDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfMaloprodajaIzvestajDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfMaloprodajaIzvestajDto>(null as any);
    }

    getKasire(): Observable<ResultOfGetKasiriZaIzvestajResponse> {
        let url_ = this.baseUrl + "/api/pos/izvestaji/get-kasire";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKasire(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKasire(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetKasiriZaIzvestajResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetKasiriZaIzvestajResponse>;
        }));
    }

    protected processGetKasire(response: HttpResponseBase): Observable<ResultOfGetKasiriZaIzvestajResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetKasiriZaIzvestajResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetKasiriZaIzvestajResponse>(null as any);
    }
}

export interface ISyncClient {
    syncInvoices(req: GetInvoicesForSyncQuery): Observable<ResultOfGetInvoicesForSyncResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class SyncClient implements ISyncClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_POS) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    syncInvoices(req: GetInvoicesForSyncQuery): Observable<ResultOfGetInvoicesForSyncResponse> {
        let url_ = this.baseUrl + "/api/pos/sync/sync-invoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetInvoicesForSyncResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetInvoicesForSyncResponse>;
        }));
    }

    protected processSyncInvoices(response: HttpResponseBase): Observable<ResultOfGetInvoicesForSyncResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetInvoicesForSyncResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetInvoicesForSyncResponse>(null as any);
    }
}

export interface IUsersClient {
    inviteKasir(email?: string | null | undefined): Observable<ResultOfString>;
    addKasir(request: AddUserCommand): Observable<ResultOfString>;
    getAllUsers(): Observable<ResultOfGetAllUsersResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class UsersClient implements IUsersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_POS) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    inviteKasir(email?: string | null | undefined): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pos/users/invite-kasira?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInviteKasir(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInviteKasir(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processInviteKasir(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    addKasir(request: AddUserCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pos/users/add-kasir";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddKasir(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddKasir(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processAddKasir(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    getAllUsers(): Observable<ResultOfGetAllUsersResponse> {
        let url_ = this.baseUrl + "/api/pos/users/get-users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfGetAllUsersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfGetAllUsersResponse>;
        }));
    }

    protected processGetAllUsers(response: HttpResponseBase): Observable<ResultOfGetAllUsersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfGetAllUsersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfGetAllUsersResponse>(null as any);
    }
}

export interface IIdentityClient {
    register(command: RegisterCommand): Observable<ResultOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class IdentityClient implements IIdentityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_POS) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    register(command: RegisterCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pos/identity/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }
}

export interface ITokensClient {
    login(request: FiskalnaLoginRequest): Observable<ResultOfFiskalnaTokenResponse>;
    refresh(request: FiskalnaRefreshTokenRequest): Observable<ResultOfFiskalnaTokenResponse>;
    refreshDeviceToken(request: FiskalnaRefreshDeviceTokenRequest): Observable<ResultOfString>;
    logoutUser(): Observable<ResultOfString>;
    sendConfirmationCode(command: SendConfirmationCodeMojaFirmaCommand): Observable<ResultOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class TokensClient implements ITokensClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_POS) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    login(request: FiskalnaLoginRequest): Observable<ResultOfFiskalnaTokenResponse> {
        let url_ = this.baseUrl + "/api/pos/tokens/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfFiskalnaTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfFiskalnaTokenResponse>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<ResultOfFiskalnaTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfFiskalnaTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfFiskalnaTokenResponse>(null as any);
    }

    refresh(request: FiskalnaRefreshTokenRequest): Observable<ResultOfFiskalnaTokenResponse> {
        let url_ = this.baseUrl + "/api/pos/tokens/refresh-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefresh(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefresh(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfFiskalnaTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfFiskalnaTokenResponse>;
        }));
    }

    protected processRefresh(response: HttpResponseBase): Observable<ResultOfFiskalnaTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfFiskalnaTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfFiskalnaTokenResponse>(null as any);
    }

    refreshDeviceToken(request: FiskalnaRefreshDeviceTokenRequest): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pos/tokens/refresh-device-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshDeviceToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshDeviceToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processRefreshDeviceToken(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    logoutUser(): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pos/tokens/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogoutUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogoutUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processLogoutUser(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }

    sendConfirmationCode(command: SendConfirmationCodeMojaFirmaCommand): Observable<ResultOfString> {
        let url_ = this.baseUrl + "/api/pos/tokens/send-confirmation-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendConfirmationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendConfirmationCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultOfString>;
        }));
    }

    protected processSendConfirmationCode(response: HttpResponseBase): Observable<ResultOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultOfString>(null as any);
    }
}

export class Result implements IResult {
    messages?: string[] | undefined;
    succeeded?: boolean;

    constructor(data?: IResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.succeeded = _data["succeeded"];
        }
    }

    static fromJS(data: any): Result {
        data = typeof data === 'object' ? data : {};
        let result = new Result();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["succeeded"] = this.succeeded;
        return data;
    }
}

export interface IResult {
    messages?: string[] | undefined;
    succeeded?: boolean;
}

export class ResultOfIEnumerableOfFiskalniArtikalInfoDto extends Result implements IResultOfIEnumerableOfFiskalniArtikalInfoDto {
    data?: FiskalniArtikalInfoDto[] | undefined;

    constructor(data?: IResultOfIEnumerableOfFiskalniArtikalInfoDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FiskalniArtikalInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfIEnumerableOfFiskalniArtikalInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfIEnumerableOfFiskalniArtikalInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfIEnumerableOfFiskalniArtikalInfoDto extends IResult {
    data?: FiskalniArtikalInfoDto[] | undefined;
}

export class FiskalniArtikalInfoDto implements IFiskalniArtikalInfoDto {
    naziv?: string | undefined;
    cene?: CenaDto | undefined;
    label?: string | undefined;
    sifra?: string | undefined;
    gtin?: string | undefined;
    barkodovi?: string[] | undefined;
    jedinicaMereDto?: JedinicaMereDto | undefined;
    groupDto?: GroupDto | undefined;
    artikalId?: number;
    tipArtikla?: TipArtikla;
    magacinId?: number | undefined;
    magacinNaziv?: string | undefined;
    jeDuplikat?: boolean;

    constructor(data?: IFiskalniArtikalInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
            this.cene = _data["cene"] ? CenaDto.fromJS(_data["cene"]) : <any>undefined;
            this.label = _data["label"];
            this.sifra = _data["sifra"];
            this.gtin = _data["gtin"];
            if (Array.isArray(_data["barkodovi"])) {
                this.barkodovi = [] as any;
                for (let item of _data["barkodovi"])
                    this.barkodovi!.push(item);
            }
            this.jedinicaMereDto = _data["jedinicaMereDto"] ? JedinicaMereDto.fromJS(_data["jedinicaMereDto"]) : <any>undefined;
            this.groupDto = _data["groupDto"] ? GroupDto.fromJS(_data["groupDto"]) : <any>undefined;
            this.artikalId = _data["artikalId"];
            this.tipArtikla = _data["tipArtikla"];
            this.magacinId = _data["magacinId"];
            this.magacinNaziv = _data["magacinNaziv"];
            this.jeDuplikat = _data["jeDuplikat"];
        }
    }

    static fromJS(data: any): FiskalniArtikalInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new FiskalniArtikalInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        data["cene"] = this.cene ? this.cene.toJSON() : <any>undefined;
        data["label"] = this.label;
        data["sifra"] = this.sifra;
        data["gtin"] = this.gtin;
        if (Array.isArray(this.barkodovi)) {
            data["barkodovi"] = [];
            for (let item of this.barkodovi)
                data["barkodovi"].push(item);
        }
        data["jedinicaMereDto"] = this.jedinicaMereDto ? this.jedinicaMereDto.toJSON() : <any>undefined;
        data["groupDto"] = this.groupDto ? this.groupDto.toJSON() : <any>undefined;
        data["artikalId"] = this.artikalId;
        data["tipArtikla"] = this.tipArtikla;
        data["magacinId"] = this.magacinId;
        data["magacinNaziv"] = this.magacinNaziv;
        data["jeDuplikat"] = this.jeDuplikat;
        return data;
    }
}

export interface IFiskalniArtikalInfoDto {
    naziv?: string | undefined;
    cene?: CenaDto | undefined;
    label?: string | undefined;
    sifra?: string | undefined;
    gtin?: string | undefined;
    barkodovi?: string[] | undefined;
    jedinicaMereDto?: JedinicaMereDto | undefined;
    groupDto?: GroupDto | undefined;
    artikalId?: number;
    tipArtikla?: TipArtikla;
    magacinId?: number | undefined;
    magacinNaziv?: string | undefined;
    jeDuplikat?: boolean;
}

export class CenaDto implements ICenaDto {
    nabavnaCena?: number;
    prodajnaCenaSaPdv?: number;
    prodajnaCenaBezPdv?: number;

    constructor(data?: ICenaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nabavnaCena = _data["nabavnaCena"];
            this.prodajnaCenaSaPdv = _data["prodajnaCenaSaPdv"];
            this.prodajnaCenaBezPdv = _data["prodajnaCenaBezPdv"];
        }
    }

    static fromJS(data: any): CenaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CenaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nabavnaCena"] = this.nabavnaCena;
        data["prodajnaCenaSaPdv"] = this.prodajnaCenaSaPdv;
        data["prodajnaCenaBezPdv"] = this.prodajnaCenaBezPdv;
        return data;
    }
}

export interface ICenaDto {
    nabavnaCena?: number;
    prodajnaCenaSaPdv?: number;
    prodajnaCenaBezPdv?: number;
}

export class JedinicaMereDto implements IJedinicaMereDto {
    jedinicaMereId?: number;
    jedinicaMereNaziv?: string | undefined;

    constructor(data?: IJedinicaMereDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jedinicaMereId = _data["jedinicaMereId"];
            this.jedinicaMereNaziv = _data["jedinicaMereNaziv"];
        }
    }

    static fromJS(data: any): JedinicaMereDto {
        data = typeof data === 'object' ? data : {};
        let result = new JedinicaMereDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jedinicaMereId"] = this.jedinicaMereId;
        data["jedinicaMereNaziv"] = this.jedinicaMereNaziv;
        return data;
    }
}

export interface IJedinicaMereDto {
    jedinicaMereId?: number;
    jedinicaMereNaziv?: string | undefined;
}

export class GroupDto implements IGroupDto {
    groupId?: number;
    groupNaziv?: string | undefined;

    constructor(data?: IGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.groupNaziv = _data["groupNaziv"];
        }
    }

    static fromJS(data: any): GroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["groupNaziv"] = this.groupNaziv;
        return data;
    }
}

export interface IGroupDto {
    groupId?: number;
    groupNaziv?: string | undefined;
}

export enum TipArtikla {
    EMPTY = 0,
    ROBA = 1,
    SIROVINE_MATERIJAL = 2,
    POLUPROIZVOD = 3,
    PROIZVOD = 4,
    USLUGA = 5,
    VOZILO = 6,
}

export class ResultOfArticleInfoResponse extends Result implements IResultOfArticleInfoResponse {
    data?: ArticleInfoResponse | undefined;

    constructor(data?: IResultOfArticleInfoResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? ArticleInfoResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfArticleInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfArticleInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfArticleInfoResponse extends IResult {
    data?: ArticleInfoResponse | undefined;
}

export class ArticleInfoResponse implements IArticleInfoResponse {
    articleId?: number;
    gtin?: string | undefined;

    constructor(data?: IArticleInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"];
            this.gtin = _data["gtin"];
        }
    }

    static fromJS(data: any): ArticleInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId;
        data["gtin"] = this.gtin;
        return data;
    }
}

export interface IArticleInfoResponse {
    articleId?: number;
    gtin?: string | undefined;
}

export class FiskalniArtikalDto implements IFiskalniArtikalDto {
    naziv?: string | undefined;
    cene?: CenaDto | undefined;
    label?: string | undefined;
    sifra?: string | undefined;
    gtin?: string | undefined;
    barkodovi?: string[] | undefined;
    jedinicaMereId?: number;
    groupId?: number | undefined;
    artikalId?: number;
    tipArtikla?: TipArtikla;
    magacini?: number[] | undefined;

    constructor(data?: IFiskalniArtikalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
            this.cene = _data["cene"] ? CenaDto.fromJS(_data["cene"]) : <any>undefined;
            this.label = _data["label"];
            this.sifra = _data["sifra"];
            this.gtin = _data["gtin"];
            if (Array.isArray(_data["barkodovi"])) {
                this.barkodovi = [] as any;
                for (let item of _data["barkodovi"])
                    this.barkodovi!.push(item);
            }
            this.jedinicaMereId = _data["jedinicaMereId"];
            this.groupId = _data["groupId"];
            this.artikalId = _data["artikalId"];
            this.tipArtikla = _data["tipArtikla"];
            if (Array.isArray(_data["magacini"])) {
                this.magacini = [] as any;
                for (let item of _data["magacini"])
                    this.magacini!.push(item);
            }
        }
    }

    static fromJS(data: any): FiskalniArtikalDto {
        data = typeof data === 'object' ? data : {};
        let result = new FiskalniArtikalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        data["cene"] = this.cene ? this.cene.toJSON() : <any>undefined;
        data["label"] = this.label;
        data["sifra"] = this.sifra;
        data["gtin"] = this.gtin;
        if (Array.isArray(this.barkodovi)) {
            data["barkodovi"] = [];
            for (let item of this.barkodovi)
                data["barkodovi"].push(item);
        }
        data["jedinicaMereId"] = this.jedinicaMereId;
        data["groupId"] = this.groupId;
        data["artikalId"] = this.artikalId;
        data["tipArtikla"] = this.tipArtikla;
        if (Array.isArray(this.magacini)) {
            data["magacini"] = [];
            for (let item of this.magacini)
                data["magacini"].push(item);
        }
        return data;
    }
}

export interface IFiskalniArtikalDto {
    naziv?: string | undefined;
    cene?: CenaDto | undefined;
    label?: string | undefined;
    sifra?: string | undefined;
    gtin?: string | undefined;
    barkodovi?: string[] | undefined;
    jedinicaMereId?: number;
    groupId?: number | undefined;
    artikalId?: number;
    tipArtikla?: TipArtikla;
    magacini?: number[] | undefined;
}

export class CreateArticleCommand extends FiskalniArtikalDto implements ICreateArticleCommand {

    constructor(data?: ICreateArticleCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateArticleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateArticleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateArticleCommand extends IFiskalniArtikalDto {
}

export class UpdateArticleCommand extends FiskalniArtikalDto implements IUpdateArticleCommand {

    constructor(data?: IUpdateArticleCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateArticleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateArticleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateArticleCommand extends IFiskalniArtikalDto {
}

export class ResultOfIEnumerableOfMagacinDto extends Result implements IResultOfIEnumerableOfMagacinDto {
    data?: MagacinDto[] | undefined;

    constructor(data?: IResultOfIEnumerableOfMagacinDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MagacinDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfIEnumerableOfMagacinDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfIEnumerableOfMagacinDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfIEnumerableOfMagacinDto extends IResult {
    data?: MagacinDto[] | undefined;
}

export class MagacinDto implements IMagacinDto {
    id?: number;
    naziv?: string;

    constructor(data?: IMagacinDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
        }
    }

    static fromJS(data: any): MagacinDto {
        data = typeof data === 'object' ? data : {};
        let result = new MagacinDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        return data;
    }
}

export interface IMagacinDto {
    id?: number;
    naziv?: string;
}

export class ResultOfLong extends Result implements IResultOfLong {
    data?: number;

    constructor(data?: IResultOfLong) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ResultOfLong {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfLong();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfLong extends IResult {
    data?: number;
}

export class ResultOfString extends Result implements IResultOfString {
    data?: string | undefined;

    constructor(data?: IResultOfString) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ResultOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfString extends IResult {
    data?: string | undefined;
}

export class ResultOfIEnumerableOfGroupDto extends Result implements IResultOfIEnumerableOfGroupDto {
    data?: GroupDto[] | undefined;

    constructor(data?: IResultOfIEnumerableOfGroupDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(GroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfIEnumerableOfGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfIEnumerableOfGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfIEnumerableOfGroupDto extends IResult {
    data?: GroupDto[] | undefined;
}

export class ResultOfIEnumerableOfUnitMeasureDto extends Result implements IResultOfIEnumerableOfUnitMeasureDto {
    data?: UnitMeasureDto[] | undefined;

    constructor(data?: IResultOfIEnumerableOfUnitMeasureDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UnitMeasureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfIEnumerableOfUnitMeasureDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfIEnumerableOfUnitMeasureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfIEnumerableOfUnitMeasureDto extends IResult {
    data?: UnitMeasureDto[] | undefined;
}

export class UnitMeasureDto implements IUnitMeasureDto {
    id?: number;
    naziv?: string | undefined;
    skracenica?: string | undefined;
    kod?: string | undefined;

    constructor(data?: IUnitMeasureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.skracenica = _data["skracenica"];
            this.kod = _data["kod"];
        }
    }

    static fromJS(data: any): UnitMeasureDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitMeasureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["skracenica"] = this.skracenica;
        data["kod"] = this.kod;
        return data;
    }
}

export interface IUnitMeasureDto {
    id?: number;
    naziv?: string | undefined;
    skracenica?: string | undefined;
    kod?: string | undefined;
}

export class ResultOfCertificateInfoResponse extends Result implements IResultOfCertificateInfoResponse {
    data?: CertificateInfoResponse | undefined;

    constructor(data?: IResultOfCertificateInfoResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? CertificateInfoResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfCertificateInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfCertificateInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfCertificateInfoResponse extends IResult {
    data?: CertificateInfoResponse | undefined;
}

export class CertificateInfoResponse implements ICertificateInfoResponse {
    naziv?: string | undefined;
    jid?: string | undefined;
    lozinka?: string | undefined;
    pak?: string | undefined;
    magacinId?: number;

    constructor(data?: ICertificateInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
            this.jid = _data["jid"];
            this.lozinka = _data["lozinka"];
            this.pak = _data["pak"];
            this.magacinId = _data["magacinId"];
        }
    }

    static fromJS(data: any): CertificateInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        data["jid"] = this.jid;
        data["lozinka"] = this.lozinka;
        data["pak"] = this.pak;
        data["magacinId"] = this.magacinId;
        return data;
    }
}

export interface ICertificateInfoResponse {
    naziv?: string | undefined;
    jid?: string | undefined;
    lozinka?: string | undefined;
    pak?: string | undefined;
    magacinId?: number;
}

export class ResultOfListOfSertifikatFiskalneKaseDto extends Result implements IResultOfListOfSertifikatFiskalneKaseDto {
    data?: SertifikatFiskalneKaseDto[] | undefined;

    constructor(data?: IResultOfListOfSertifikatFiskalneKaseDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SertifikatFiskalneKaseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfListOfSertifikatFiskalneKaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfListOfSertifikatFiskalneKaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfListOfSertifikatFiskalneKaseDto extends IResult {
    data?: SertifikatFiskalneKaseDto[] | undefined;
}

export class SertifikatFiskalneKaseDto implements ISertifikatFiskalneKaseDto {
    naziv?: string | undefined;
    jid?: string | undefined;
    tip?: TipBezbednosnogElementa;

    constructor(data?: ISertifikatFiskalneKaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
            this.jid = _data["jid"];
            this.tip = _data["tip"];
        }
    }

    static fromJS(data: any): SertifikatFiskalneKaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SertifikatFiskalneKaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        data["jid"] = this.jid;
        data["tip"] = this.tip;
        return data;
    }
}

export interface ISertifikatFiskalneKaseDto {
    naziv?: string | undefined;
    jid?: string | undefined;
    tip?: TipBezbednosnogElementa;
}

export enum TipBezbednosnogElementa {
    LPFR = 0,
    VPFR = 1,
}

export class ResultOfCompanyDto extends Result implements IResultOfCompanyDto {
    data?: CompanyDto | undefined;

    constructor(data?: IResultOfCompanyDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? CompanyDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfCompanyDto extends IResult {
    data?: CompanyDto | undefined;
}

export class CompanyDto implements ICompanyDto {
    naziv?: string;
    adresa?: string;
    pib?: string;
    mb?: string;

    constructor(data?: ICompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
            this.adresa = _data["adresa"];
            this.pib = _data["pib"];
            this.mb = _data["mb"];
        }
    }

    static fromJS(data: any): CompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        data["adresa"] = this.adresa;
        data["pib"] = this.pib;
        data["mb"] = this.mb;
        return data;
    }
}

export interface ICompanyDto {
    naziv?: string;
    adresa?: string;
    pib?: string;
    mb?: string;
}

export class ResultOfIEnumerableOfStrankaPosDto extends Result implements IResultOfIEnumerableOfStrankaPosDto {
    data?: StrankaPosDto[] | undefined;

    constructor(data?: IResultOfIEnumerableOfStrankaPosDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StrankaPosDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultOfIEnumerableOfStrankaPosDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfIEnumerableOfStrankaPosDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfIEnumerableOfStrankaPosDto extends IResult {
    data?: StrankaPosDto[] | undefined;
}

export class StrankaPosDto implements IStrankaPosDto {
    id?: number;
    pib?: string | undefined;
    mb?: string | undefined;
    naziv?: string | undefined;
    adresa?: string | undefined;

    constructor(data?: IStrankaPosDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pib = _data["pib"];
            this.mb = _data["mb"];
            this.naziv = _data["naziv"];
            this.adresa = _data["adresa"];
        }
    }

    static fromJS(data: any): StrankaPosDto {
        data = typeof data === 'object' ? data : {};
        let result = new StrankaPosDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pib"] = this.pib;
        data["mb"] = this.mb;
        data["naziv"] = this.naziv;
        data["adresa"] = this.adresa;
        return data;
    }
}

export interface IStrankaPosDto {
    id?: number;
    pib?: string | undefined;
    mb?: string | undefined;
    naziv?: string | undefined;
    adresa?: string | undefined;
}

export class GetAllCustomersQuery implements IGetAllCustomersQuery {
    nazivPibMb?: string | undefined;

    constructor(data?: IGetAllCustomersQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nazivPibMb = _data["nazivPibMb"];
        }
    }

    static fromJS(data: any): GetAllCustomersQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllCustomersQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nazivPibMb"] = this.nazivPibMb;
        return data;
    }
}

export interface IGetAllCustomersQuery {
    nazivPibMb?: string | undefined;
}

export class ResultOfGetAllUsersResponse extends Result implements IResultOfGetAllUsersResponse {
    data?: GetAllUsersResponse | undefined;

    constructor(data?: IResultOfGetAllUsersResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetAllUsersResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetAllUsersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetAllUsersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetAllUsersResponse extends IResult {
    data?: GetAllUsersResponse | undefined;
}

export class GetAllUsersResponse implements IGetAllUsersResponse {
    users?: UserDto[] | undefined;

    constructor(data?: IGetAllUsersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllUsersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllUsersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllUsersResponse {
    users?: UserDto[] | undefined;
}

export class UserDto implements IUserDto {
    naziv?: string | undefined;
    email?: string | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naziv = _data["naziv"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naziv"] = this.naziv;
        data["email"] = this.email;
        return data;
    }
}

export interface IUserDto {
    naziv?: string | undefined;
    email?: string | undefined;
}

export class InvoiceSubjectResponse implements IInvoiceSubjectResponse {
    address?: string | undefined;
    businessName?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    district?: string | undefined;
    locationName?: string | undefined;
    tin?: string | undefined;
    uid?: string | undefined;

    constructor(data?: IInvoiceSubjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.businessName = _data["businessName"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.district = _data["district"];
            this.locationName = _data["locationName"];
            this.tin = _data["tin"];
            this.uid = _data["uid"];
        }
    }

    static fromJS(data: any): InvoiceSubjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceSubjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["businessName"] = this.businessName;
        data["city"] = this.city;
        data["country"] = this.country;
        data["district"] = this.district;
        data["locationName"] = this.locationName;
        data["tin"] = this.tin;
        data["uid"] = this.uid;
        return data;
    }
}

export interface IInvoiceSubjectResponse {
    address?: string | undefined;
    businessName?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    district?: string | undefined;
    locationName?: string | undefined;
    tin?: string | undefined;
    uid?: string | undefined;
}

export class CreateBezbednosniElementLPFRCommand extends InvoiceSubjectResponse implements ICreateBezbednosniElementLPFRCommand {

    constructor(data?: ICreateBezbednosniElementLPFRCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateBezbednosniElementLPFRCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBezbednosniElementLPFRCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateBezbednosniElementLPFRCommand extends IInvoiceSubjectResponse {
}

export class SaveInvoiceCommand implements ISaveInvoiceCommand {
    invoiceRequest?: InvoiceRequestDto;
    invoiceResponse?: InvoiceResponseDto;

    constructor(data?: ISaveInvoiceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceRequest = _data["invoiceRequest"] ? InvoiceRequestDto.fromJS(_data["invoiceRequest"]) : <any>undefined;
            this.invoiceResponse = _data["invoiceResponse"] ? InvoiceResponseDto.fromJS(_data["invoiceResponse"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveInvoiceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveInvoiceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceRequest"] = this.invoiceRequest ? this.invoiceRequest.toJSON() : <any>undefined;
        data["invoiceResponse"] = this.invoiceResponse ? this.invoiceResponse.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveInvoiceCommand {
    invoiceRequest?: InvoiceRequestDto;
    invoiceResponse?: InvoiceResponseDto;
}

export class InvoiceRequestDto implements IInvoiceRequestDto {
    dateAndTimeOfIssue?: Date | undefined;
    cashier?: string | undefined;
    buyerId?: string | undefined;
    buyerIdentification?: BuyerIdentification | undefined;
    buyerCostCenterId?: string | undefined;
    buyerOptionalField?: BuyerOptionalField | undefined;
    invoiceType?: InvoiceType;
    transactionType?: TransactionType;
    invoiceNumber?: string | undefined;
    referentDocumentNumber?: string | undefined;
    referentDocumentDT?: Date | undefined;
    option?: InvoiceOptionDto | undefined;
    journalOption?: JournalOptionDto | undefined;
    items?: InvoiceItemDto[] | undefined;
    payment?: InvoicePaymentDto[] | undefined;

    constructor(data?: IInvoiceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateAndTimeOfIssue = _data["dateAndTimeOfIssue"] ? new Date(_data["dateAndTimeOfIssue"].toString()) : <any>undefined;
            this.cashier = _data["cashier"];
            this.buyerId = _data["buyerId"];
            this.buyerIdentification = _data["buyerIdentification"];
            this.buyerCostCenterId = _data["buyerCostCenterId"];
            this.buyerOptionalField = _data["buyerOptionalField"];
            this.invoiceType = _data["invoiceType"];
            this.transactionType = _data["transactionType"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.referentDocumentNumber = _data["referentDocumentNumber"];
            this.referentDocumentDT = _data["referentDocumentDT"] ? new Date(_data["referentDocumentDT"].toString()) : <any>undefined;
            this.option = _data["option"] ? InvoiceOptionDto.fromJS(_data["option"]) : <any>undefined;
            this.journalOption = _data["journalOption"] ? JournalOptionDto.fromJS(_data["journalOption"]) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InvoiceItemDto.fromJS(item));
            }
            if (Array.isArray(_data["payment"])) {
                this.payment = [] as any;
                for (let item of _data["payment"])
                    this.payment!.push(InvoicePaymentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoiceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateAndTimeOfIssue"] = this.dateAndTimeOfIssue ? this.dateAndTimeOfIssue.toISOString() : <any>undefined;
        data["cashier"] = this.cashier;
        data["buyerId"] = this.buyerId;
        data["buyerIdentification"] = this.buyerIdentification;
        data["buyerCostCenterId"] = this.buyerCostCenterId;
        data["buyerOptionalField"] = this.buyerOptionalField;
        data["invoiceType"] = this.invoiceType;
        data["transactionType"] = this.transactionType;
        data["invoiceNumber"] = this.invoiceNumber;
        data["referentDocumentNumber"] = this.referentDocumentNumber;
        data["referentDocumentDT"] = this.referentDocumentDT ? this.referentDocumentDT.toISOString() : <any>undefined;
        data["option"] = this.option ? this.option.toJSON() : <any>undefined;
        data["journalOption"] = this.journalOption ? this.journalOption.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.payment)) {
            data["payment"] = [];
            for (let item of this.payment)
                data["payment"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInvoiceRequestDto {
    dateAndTimeOfIssue?: Date | undefined;
    cashier?: string | undefined;
    buyerId?: string | undefined;
    buyerIdentification?: BuyerIdentification | undefined;
    buyerCostCenterId?: string | undefined;
    buyerOptionalField?: BuyerOptionalField | undefined;
    invoiceType?: InvoiceType;
    transactionType?: TransactionType;
    invoiceNumber?: string | undefined;
    referentDocumentNumber?: string | undefined;
    referentDocumentDT?: Date | undefined;
    option?: InvoiceOptionDto | undefined;
    journalOption?: JournalOptionDto | undefined;
    items?: InvoiceItemDto[] | undefined;
    payment?: InvoicePaymentDto[] | undefined;
}

export enum BuyerIdentification {
    EMPTY = 0,
    PIB_KUPCA = 10,
    JMBG = 11,
    PPIB_I_JBKJS = 12,
    BROJ_LICNE = 20,
    BROJ_IZBEGLICKE_LEGITIMACIJE = 21,
    EBS = 22,
    BROJ_PASOSA = 23,
    BROJ_PASOSA_STRANO_LICE = 30,
    BROJ_DIPLOMATSKE_LEGITIMACIJE = 31,
    BROJ_LICNE_MKD = 32,
    BROJ_LICNE_MNE = 33,
    BROJ_LICNE_ALB = 34,
    BROJ_LICNE_BIH = 35,
    BROJ_LICNE_PO_ODLUCI = 36,
    PORESKI_ID_IZ_STRANE_DRZAVE = 40,
}

export enum BuyerOptionalField {
    Empty = 0,
    BROJ_SNPDV = 20,
    LNPDV = 21,
    BROJ_PPO_PDV = 30,
    BROJ_ZPPO_PDV = 31,
    BROJ_MPPO_PDV = 32,
    BROJ_IPPO_PDV = 33,
    BROJ_KORPORACIJSKE_KARTICE = 50,
    VREMENSKI_PERIOD = 60,
}

export enum InvoiceType {
    NORMAL = 0,
    PROFORMA = 1,
    COPY = 2,
    TRAINING = 3,
    ADVANCE = 4,
}

export enum TransactionType {
    SALE = 0,
    REFUND = 1,
}

export class InvoiceOptionDto implements IInvoiceOptionDto {
    omitQRCodeGen?: Omit;
    omitTextualRepresentation?: Omit;

    constructor(data?: IInvoiceOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.omitQRCodeGen = _data["omitQRCodeGen"];
            this.omitTextualRepresentation = _data["omitTextualRepresentation"];
        }
    }

    static fromJS(data: any): InvoiceOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["omitQRCodeGen"] = this.omitQRCodeGen;
        data["omitTextualRepresentation"] = this.omitTextualRepresentation;
        return data;
    }
}

export interface IInvoiceOptionDto {
    omitQRCodeGen?: Omit;
    omitTextualRepresentation?: Omit;
}

export enum Omit {
    RETURN = 0,
    OMIT_GENERATION = 1,
}

export class JournalOptionDto implements IJournalOptionDto {
    print?: boolean | undefined;
    a4Printer?: string | undefined;
    message?: string | undefined;
    preamble?: string | undefined;
    advance?: number | undefined;
    advanceTax?: number | undefined;

    constructor(data?: IJournalOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.print = _data["print"];
            this.a4Printer = _data["a4Printer"];
            this.message = _data["message"];
            this.preamble = _data["preamble"];
            this.advance = _data["advance"];
            this.advanceTax = _data["advanceTax"];
        }
    }

    static fromJS(data: any): JournalOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new JournalOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["print"] = this.print;
        data["a4Printer"] = this.a4Printer;
        data["message"] = this.message;
        data["preamble"] = this.preamble;
        data["advance"] = this.advance;
        data["advanceTax"] = this.advanceTax;
        return data;
    }
}

export interface IJournalOptionDto {
    print?: boolean | undefined;
    a4Printer?: string | undefined;
    message?: string | undefined;
    preamble?: string | undefined;
    advance?: number | undefined;
    advanceTax?: number | undefined;
}

export class InvoiceItemDto implements IInvoiceItemDto {
    gtin?: string | undefined;
    name?: string | undefined;
    quantity?: number;
    totalAmount?: number;
    unitPrice?: number;
    discount?: number | undefined;
    magacinId?: number | undefined;
    labels?: string[] | undefined;
    predmetStavkeId?: number | undefined;

    constructor(data?: IInvoiceItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gtin = _data["gtin"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.totalAmount = _data["totalAmount"];
            this.unitPrice = _data["unitPrice"];
            this.discount = _data["discount"];
            this.magacinId = _data["magacinId"];
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(item);
            }
            this.predmetStavkeId = _data["predmetStavkeId"];
        }
    }

    static fromJS(data: any): InvoiceItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gtin"] = this.gtin;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["totalAmount"] = this.totalAmount;
        data["unitPrice"] = this.unitPrice;
        data["discount"] = this.discount;
        data["magacinId"] = this.magacinId;
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item);
        }
        data["predmetStavkeId"] = this.predmetStavkeId;
        return data;
    }
}

export interface IInvoiceItemDto {
    gtin?: string | undefined;
    name?: string | undefined;
    quantity?: number;
    totalAmount?: number;
    unitPrice?: number;
    discount?: number | undefined;
    magacinId?: number | undefined;
    labels?: string[] | undefined;
    predmetStavkeId?: number | undefined;
}

export class InvoicePaymentDto implements IInvoicePaymentDto {
    amount?: number;
    paymentType?: PaymentType;

    constructor(data?: IInvoicePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.paymentType = _data["paymentType"];
        }
    }

    static fromJS(data: any): InvoicePaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicePaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["paymentType"] = this.paymentType;
        return data;
    }
}

export interface IInvoicePaymentDto {
    amount?: number;
    paymentType?: PaymentType;
}

export enum PaymentType {
    OTHER = 0,
    CASH = 1,
    CARD = 2,
    CHECK = 3,
    WIRE_TRANSFER = 4,
    VOUCHER = 5,
    MOBILE_MONEY = 6,
}

export class InvoiceResponseDto implements IInvoiceResponseDto {
    requestedBy?: string | undefined;
    sdcDateTime?: string | undefined;
    invoiceCounter?: string | undefined;
    invoiceCounterExtension?: string | undefined;
    invoiceNumber?: string | undefined;
    verificationUrl?: string | undefined;
    verificationQRCode?: string | undefined;
    journal?: string | undefined;
    messages?: string | undefined;
    signedBy?: string | undefined;
    encryptedInternalData?: string | undefined;
    signature?: string | undefined;
    totalCounter?: number;
    transactionTypeCounter?: number;
    totalAmount?: number;
    taxGroupRevision?: number;
    businessName?: string | undefined;
    tin?: string | undefined;
    locationName?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    mrc?: string | undefined;
    taxItems?: InvoiceTaxItemDto[] | undefined;
    isRefunded?: number;

    constructor(data?: IInvoiceResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestedBy = _data["requestedBy"];
            this.sdcDateTime = _data["sdcDateTime"];
            this.invoiceCounter = _data["invoiceCounter"];
            this.invoiceCounterExtension = _data["invoiceCounterExtension"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.verificationUrl = _data["verificationUrl"];
            this.verificationQRCode = _data["verificationQRCode"];
            this.journal = _data["journal"];
            this.messages = _data["messages"];
            this.signedBy = _data["signedBy"];
            this.encryptedInternalData = _data["encryptedInternalData"];
            this.signature = _data["signature"];
            this.totalCounter = _data["totalCounter"];
            this.transactionTypeCounter = _data["transactionTypeCounter"];
            this.totalAmount = _data["totalAmount"];
            this.taxGroupRevision = _data["taxGroupRevision"];
            this.businessName = _data["businessName"];
            this.tin = _data["tin"];
            this.locationName = _data["locationName"];
            this.address = _data["address"];
            this.district = _data["district"];
            this.mrc = _data["mrc"];
            if (Array.isArray(_data["taxItems"])) {
                this.taxItems = [] as any;
                for (let item of _data["taxItems"])
                    this.taxItems!.push(InvoiceTaxItemDto.fromJS(item));
            }
            this.isRefunded = _data["isRefunded"];
        }
    }

    static fromJS(data: any): InvoiceResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestedBy"] = this.requestedBy;
        data["sdcDateTime"] = this.sdcDateTime;
        data["invoiceCounter"] = this.invoiceCounter;
        data["invoiceCounterExtension"] = this.invoiceCounterExtension;
        data["invoiceNumber"] = this.invoiceNumber;
        data["verificationUrl"] = this.verificationUrl;
        data["verificationQRCode"] = this.verificationQRCode;
        data["journal"] = this.journal;
        data["messages"] = this.messages;
        data["signedBy"] = this.signedBy;
        data["encryptedInternalData"] = this.encryptedInternalData;
        data["signature"] = this.signature;
        data["totalCounter"] = this.totalCounter;
        data["transactionTypeCounter"] = this.transactionTypeCounter;
        data["totalAmount"] = this.totalAmount;
        data["taxGroupRevision"] = this.taxGroupRevision;
        data["businessName"] = this.businessName;
        data["tin"] = this.tin;
        data["locationName"] = this.locationName;
        data["address"] = this.address;
        data["district"] = this.district;
        data["mrc"] = this.mrc;
        if (Array.isArray(this.taxItems)) {
            data["taxItems"] = [];
            for (let item of this.taxItems)
                data["taxItems"].push(item.toJSON());
        }
        data["isRefunded"] = this.isRefunded;
        return data;
    }
}

export interface IInvoiceResponseDto {
    requestedBy?: string | undefined;
    sdcDateTime?: string | undefined;
    invoiceCounter?: string | undefined;
    invoiceCounterExtension?: string | undefined;
    invoiceNumber?: string | undefined;
    verificationUrl?: string | undefined;
    verificationQRCode?: string | undefined;
    journal?: string | undefined;
    messages?: string | undefined;
    signedBy?: string | undefined;
    encryptedInternalData?: string | undefined;
    signature?: string | undefined;
    totalCounter?: number;
    transactionTypeCounter?: number;
    totalAmount?: number;
    taxGroupRevision?: number;
    businessName?: string | undefined;
    tin?: string | undefined;
    locationName?: string | undefined;
    address?: string | undefined;
    district?: string | undefined;
    mrc?: string | undefined;
    taxItems?: InvoiceTaxItemDto[] | undefined;
    isRefunded?: number;
}

export class InvoiceTaxItemDto implements IInvoiceTaxItemDto {
    amount?: number;
    categoryName?: string | undefined;
    categoryType?: TaxCategoryType;
    label?: string | undefined;
    rate?: number;

    constructor(data?: IInvoiceTaxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.categoryName = _data["categoryName"];
            this.categoryType = _data["categoryType"];
            this.label = _data["label"];
            this.rate = _data["rate"];
        }
    }

    static fromJS(data: any): InvoiceTaxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceTaxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["categoryName"] = this.categoryName;
        data["categoryType"] = this.categoryType;
        data["label"] = this.label;
        data["rate"] = this.rate;
        return data;
    }
}

export interface IInvoiceTaxItemDto {
    amount?: number;
    categoryName?: string | undefined;
    categoryType?: TaxCategoryType;
    label?: string | undefined;
    rate?: number;
}

export enum TaxCategoryType {
    TAX_ONE_NET = 0,
    TAX_ON_TOTAL = 1,
    AMOUNT_PER_QUANTITY = 2,
}

export class ResultOfMaloprodajaIzvestajDto extends Result implements IResultOfMaloprodajaIzvestajDto {
    data?: MaloprodajaIzvestajDto | undefined;

    constructor(data?: IResultOfMaloprodajaIzvestajDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? MaloprodajaIzvestajDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfMaloprodajaIzvestajDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfMaloprodajaIzvestajDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfMaloprodajaIzvestajDto extends IResult {
    data?: MaloprodajaIzvestajDto | undefined;
}

export class MaloprodajaIzvestajDto implements IMaloprodajaIzvestajDto {
    nazivPoreskogObveznika?: string | undefined;
    pib?: string | undefined;
    adresaObjekta?: string | undefined;
    grad?: string | undefined;
    prometProdaja?: number;
    prometRefundacija?: number;
    prometUkupno?: number;
    avansProdaja?: number;
    avansRealizacija?: number;
    avansRefundacija?: number;
    avansUkupno?: number;
    ukupnoPorezZaPrometProdaju?: number;
    ukupnoPorezZaPrometRefundaciju?: number;
    saldoPorezaPromet?: number;
    ukupnoPorezZaAvansProdaju?: number;
    ukupnoPorezZaAvansRefundaciju?: number;
    saldoPorezaAvans?: number;
    prometPoNacinuPlacanja?: TabelePoNacinuPlacanjaDto[] | undefined;
    avansPoNacinuPlacanja?: TabelePoNacinuPlacanjaDto[] | undefined;
    stanjeBlagajne?: TabelePoNacinuPlacanjaDto[] | undefined;
    ukupnoPrometPoNacinuPlacanja?: number;
    ukupnoAvansPoNacinuPlacanja?: number;
    ukupnoStanjeBlagajne?: number;
    prometPoStopama?: PrometPoStopamaDto[] | undefined;
    ukupnoPorezPoStopama?: number;
    kusur?: number | undefined;
    brojPrometProdaja?: number;
    brojPrometRefundacija?: number;
    brojAvansProdaja?: number;
    brojAvansRefundacija?: number;

    constructor(data?: IMaloprodajaIzvestajDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nazivPoreskogObveznika = _data["nazivPoreskogObveznika"];
            this.pib = _data["pib"];
            this.adresaObjekta = _data["adresaObjekta"];
            this.grad = _data["grad"];
            this.prometProdaja = _data["prometProdaja"];
            this.prometRefundacija = _data["prometRefundacija"];
            this.prometUkupno = _data["prometUkupno"];
            this.avansProdaja = _data["avansProdaja"];
            this.avansRealizacija = _data["avansRealizacija"];
            this.avansRefundacija = _data["avansRefundacija"];
            this.avansUkupno = _data["avansUkupno"];
            this.ukupnoPorezZaPrometProdaju = _data["ukupnoPorezZaPrometProdaju"];
            this.ukupnoPorezZaPrometRefundaciju = _data["ukupnoPorezZaPrometRefundaciju"];
            this.saldoPorezaPromet = _data["saldoPorezaPromet"];
            this.ukupnoPorezZaAvansProdaju = _data["ukupnoPorezZaAvansProdaju"];
            this.ukupnoPorezZaAvansRefundaciju = _data["ukupnoPorezZaAvansRefundaciju"];
            this.saldoPorezaAvans = _data["saldoPorezaAvans"];
            if (Array.isArray(_data["prometPoNacinuPlacanja"])) {
                this.prometPoNacinuPlacanja = [] as any;
                for (let item of _data["prometPoNacinuPlacanja"])
                    this.prometPoNacinuPlacanja!.push(TabelePoNacinuPlacanjaDto.fromJS(item));
            }
            if (Array.isArray(_data["avansPoNacinuPlacanja"])) {
                this.avansPoNacinuPlacanja = [] as any;
                for (let item of _data["avansPoNacinuPlacanja"])
                    this.avansPoNacinuPlacanja!.push(TabelePoNacinuPlacanjaDto.fromJS(item));
            }
            if (Array.isArray(_data["stanjeBlagajne"])) {
                this.stanjeBlagajne = [] as any;
                for (let item of _data["stanjeBlagajne"])
                    this.stanjeBlagajne!.push(TabelePoNacinuPlacanjaDto.fromJS(item));
            }
            this.ukupnoPrometPoNacinuPlacanja = _data["ukupnoPrometPoNacinuPlacanja"];
            this.ukupnoAvansPoNacinuPlacanja = _data["ukupnoAvansPoNacinuPlacanja"];
            this.ukupnoStanjeBlagajne = _data["ukupnoStanjeBlagajne"];
            if (Array.isArray(_data["prometPoStopama"])) {
                this.prometPoStopama = [] as any;
                for (let item of _data["prometPoStopama"])
                    this.prometPoStopama!.push(PrometPoStopamaDto.fromJS(item));
            }
            this.ukupnoPorezPoStopama = _data["ukupnoPorezPoStopama"];
            this.kusur = _data["kusur"];
            this.brojPrometProdaja = _data["brojPrometProdaja"];
            this.brojPrometRefundacija = _data["brojPrometRefundacija"];
            this.brojAvansProdaja = _data["brojAvansProdaja"];
            this.brojAvansRefundacija = _data["brojAvansRefundacija"];
        }
    }

    static fromJS(data: any): MaloprodajaIzvestajDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaloprodajaIzvestajDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nazivPoreskogObveznika"] = this.nazivPoreskogObveznika;
        data["pib"] = this.pib;
        data["adresaObjekta"] = this.adresaObjekta;
        data["grad"] = this.grad;
        data["prometProdaja"] = this.prometProdaja;
        data["prometRefundacija"] = this.prometRefundacija;
        data["prometUkupno"] = this.prometUkupno;
        data["avansProdaja"] = this.avansProdaja;
        data["avansRealizacija"] = this.avansRealizacija;
        data["avansRefundacija"] = this.avansRefundacija;
        data["avansUkupno"] = this.avansUkupno;
        data["ukupnoPorezZaPrometProdaju"] = this.ukupnoPorezZaPrometProdaju;
        data["ukupnoPorezZaPrometRefundaciju"] = this.ukupnoPorezZaPrometRefundaciju;
        data["saldoPorezaPromet"] = this.saldoPorezaPromet;
        data["ukupnoPorezZaAvansProdaju"] = this.ukupnoPorezZaAvansProdaju;
        data["ukupnoPorezZaAvansRefundaciju"] = this.ukupnoPorezZaAvansRefundaciju;
        data["saldoPorezaAvans"] = this.saldoPorezaAvans;
        if (Array.isArray(this.prometPoNacinuPlacanja)) {
            data["prometPoNacinuPlacanja"] = [];
            for (let item of this.prometPoNacinuPlacanja)
                data["prometPoNacinuPlacanja"].push(item.toJSON());
        }
        if (Array.isArray(this.avansPoNacinuPlacanja)) {
            data["avansPoNacinuPlacanja"] = [];
            for (let item of this.avansPoNacinuPlacanja)
                data["avansPoNacinuPlacanja"].push(item.toJSON());
        }
        if (Array.isArray(this.stanjeBlagajne)) {
            data["stanjeBlagajne"] = [];
            for (let item of this.stanjeBlagajne)
                data["stanjeBlagajne"].push(item.toJSON());
        }
        data["ukupnoPrometPoNacinuPlacanja"] = this.ukupnoPrometPoNacinuPlacanja;
        data["ukupnoAvansPoNacinuPlacanja"] = this.ukupnoAvansPoNacinuPlacanja;
        data["ukupnoStanjeBlagajne"] = this.ukupnoStanjeBlagajne;
        if (Array.isArray(this.prometPoStopama)) {
            data["prometPoStopama"] = [];
            for (let item of this.prometPoStopama)
                data["prometPoStopama"].push(item.toJSON());
        }
        data["ukupnoPorezPoStopama"] = this.ukupnoPorezPoStopama;
        data["kusur"] = this.kusur;
        data["brojPrometProdaja"] = this.brojPrometProdaja;
        data["brojPrometRefundacija"] = this.brojPrometRefundacija;
        data["brojAvansProdaja"] = this.brojAvansProdaja;
        data["brojAvansRefundacija"] = this.brojAvansRefundacija;
        return data;
    }
}

export interface IMaloprodajaIzvestajDto {
    nazivPoreskogObveznika?: string | undefined;
    pib?: string | undefined;
    adresaObjekta?: string | undefined;
    grad?: string | undefined;
    prometProdaja?: number;
    prometRefundacija?: number;
    prometUkupno?: number;
    avansProdaja?: number;
    avansRealizacija?: number;
    avansRefundacija?: number;
    avansUkupno?: number;
    ukupnoPorezZaPrometProdaju?: number;
    ukupnoPorezZaPrometRefundaciju?: number;
    saldoPorezaPromet?: number;
    ukupnoPorezZaAvansProdaju?: number;
    ukupnoPorezZaAvansRefundaciju?: number;
    saldoPorezaAvans?: number;
    prometPoNacinuPlacanja?: TabelePoNacinuPlacanjaDto[] | undefined;
    avansPoNacinuPlacanja?: TabelePoNacinuPlacanjaDto[] | undefined;
    stanjeBlagajne?: TabelePoNacinuPlacanjaDto[] | undefined;
    ukupnoPrometPoNacinuPlacanja?: number;
    ukupnoAvansPoNacinuPlacanja?: number;
    ukupnoStanjeBlagajne?: number;
    prometPoStopama?: PrometPoStopamaDto[] | undefined;
    ukupnoPorezPoStopama?: number;
    kusur?: number | undefined;
    brojPrometProdaja?: number;
    brojPrometRefundacija?: number;
    brojAvansProdaja?: number;
    brojAvansRefundacija?: number;
}

export class TabelePoNacinuPlacanjaDto implements ITabelePoNacinuPlacanjaDto {
    tipPlacanja?: string | undefined;
    prodaja?: number;
    refundacija?: number;
    ukupno?: number;

    constructor(data?: ITabelePoNacinuPlacanjaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipPlacanja = _data["tipPlacanja"];
            this.prodaja = _data["prodaja"];
            this.refundacija = _data["refundacija"];
            this.ukupno = _data["ukupno"];
        }
    }

    static fromJS(data: any): TabelePoNacinuPlacanjaDto {
        data = typeof data === 'object' ? data : {};
        let result = new TabelePoNacinuPlacanjaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipPlacanja"] = this.tipPlacanja;
        data["prodaja"] = this.prodaja;
        data["refundacija"] = this.refundacija;
        data["ukupno"] = this.ukupno;
        return data;
    }
}

export interface ITabelePoNacinuPlacanjaDto {
    tipPlacanja?: string | undefined;
    prodaja?: number;
    refundacija?: number;
    ukupno?: number;
}

export class PrometPoStopamaDto implements IPrometPoStopamaDto {
    oznaka?: string | undefined;
    ime?: string | undefined;
    stopa?: number;
    porez?: number;

    constructor(data?: IPrometPoStopamaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oznaka = _data["oznaka"];
            this.ime = _data["ime"];
            this.stopa = _data["stopa"];
            this.porez = _data["porez"];
        }
    }

    static fromJS(data: any): PrometPoStopamaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrometPoStopamaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oznaka"] = this.oznaka;
        data["ime"] = this.ime;
        data["stopa"] = this.stopa;
        data["porez"] = this.porez;
        return data;
    }
}

export interface IPrometPoStopamaDto {
    oznaka?: string | undefined;
    ime?: string | undefined;
    stopa?: number;
    porez?: number;
}

export class ResultOfGetKasiriZaIzvestajResponse extends Result implements IResultOfGetKasiriZaIzvestajResponse {
    data?: GetKasiriZaIzvestajResponse | undefined;

    constructor(data?: IResultOfGetKasiriZaIzvestajResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetKasiriZaIzvestajResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetKasiriZaIzvestajResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetKasiriZaIzvestajResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetKasiriZaIzvestajResponse extends IResult {
    data?: GetKasiriZaIzvestajResponse | undefined;
}

export class GetKasiriZaIzvestajResponse implements IGetKasiriZaIzvestajResponse {
    kasiri?: KorisnikAutocompleteDto[] | undefined;

    constructor(data?: IGetKasiriZaIzvestajResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["kasiri"])) {
                this.kasiri = [] as any;
                for (let item of _data["kasiri"])
                    this.kasiri!.push(KorisnikAutocompleteDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetKasiriZaIzvestajResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetKasiriZaIzvestajResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.kasiri)) {
            data["kasiri"] = [];
            for (let item of this.kasiri)
                data["kasiri"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetKasiriZaIzvestajResponse {
    kasiri?: KorisnikAutocompleteDto[] | undefined;
}

export class KorisnikAutocompleteDto implements IKorisnikAutocompleteDto {
    id?: string | undefined;
    naziv?: string | undefined;
    email?: string | undefined;
    roles?: string | undefined;

    constructor(data?: IKorisnikAutocompleteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.naziv = _data["naziv"];
            this.email = _data["email"];
            this.roles = _data["roles"];
        }
    }

    static fromJS(data: any): KorisnikAutocompleteDto {
        data = typeof data === 'object' ? data : {};
        let result = new KorisnikAutocompleteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["naziv"] = this.naziv;
        data["email"] = this.email;
        data["roles"] = this.roles;
        return data;
    }
}

export interface IKorisnikAutocompleteDto {
    id?: string | undefined;
    naziv?: string | undefined;
    email?: string | undefined;
    roles?: string | undefined;
}

export class ResultOfGetInvoicesForSyncResponse extends Result implements IResultOfGetInvoicesForSyncResponse {
    data?: GetInvoicesForSyncResponse | undefined;

    constructor(data?: IResultOfGetInvoicesForSyncResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GetInvoicesForSyncResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfGetInvoicesForSyncResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfGetInvoicesForSyncResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfGetInvoicesForSyncResponse extends IResult {
    data?: GetInvoicesForSyncResponse | undefined;
}

export class GetInvoicesForSyncResponse implements IGetInvoicesForSyncResponse {
    invoices?: InvoiceSyncRecord[];
    hasMore?: boolean;
    lastCreatedOn?: Date | undefined;

    constructor(data?: IGetInvoicesForSyncResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(InvoiceSyncRecord.fromJS(item));
            }
            this.hasMore = _data["hasMore"];
            this.lastCreatedOn = _data["lastCreatedOn"] ? new Date(_data["lastCreatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetInvoicesForSyncResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvoicesForSyncResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        data["hasMore"] = this.hasMore;
        data["lastCreatedOn"] = this.lastCreatedOn ? this.lastCreatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetInvoicesForSyncResponse {
    invoices?: InvoiceSyncRecord[];
    hasMore?: boolean;
    lastCreatedOn?: Date | undefined;
}

export class InvoiceSyncRecord implements IInvoiceSyncRecord {
    invoiceRequest?: InvoiceRequestDto | undefined;
    invoiceResponse?: InvoiceResponseDto | undefined;

    constructor(data?: IInvoiceSyncRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceRequest = _data["invoiceRequest"] ? InvoiceRequestDto.fromJS(_data["invoiceRequest"]) : <any>undefined;
            this.invoiceResponse = _data["invoiceResponse"] ? InvoiceResponseDto.fromJS(_data["invoiceResponse"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InvoiceSyncRecord {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceSyncRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceRequest"] = this.invoiceRequest ? this.invoiceRequest.toJSON() : <any>undefined;
        data["invoiceResponse"] = this.invoiceResponse ? this.invoiceResponse.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInvoiceSyncRecord {
    invoiceRequest?: InvoiceRequestDto | undefined;
    invoiceResponse?: InvoiceResponseDto | undefined;
}

export class GetInvoicesForSyncQuery implements IGetInvoicesForSyncQuery {
    lastSynced?: Date | undefined;

    constructor(data?: IGetInvoicesForSyncQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastSynced = _data["lastSynced"] ? new Date(_data["lastSynced"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetInvoicesForSyncQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvoicesForSyncQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastSynced"] = this.lastSynced ? this.lastSynced.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetInvoicesForSyncQuery {
    lastSynced?: Date | undefined;
}

export class AddUserCommand implements IAddUserCommand {
    ime?: string;
    prezime?: string;
    email?: string;

    constructor(data?: IAddUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ime = _data["ime"];
            this.prezime = _data["prezime"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): AddUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ime"] = this.ime;
        data["prezime"] = this.prezime;
        data["email"] = this.email;
        return data;
    }
}

export interface IAddUserCommand {
    ime?: string;
    prezime?: string;
    email?: string;
}

export class RegisterCommand implements IRegisterCommand {
    podaciKorisnika?: PodaciKorisnikaDto;
    confirmationCode?: string;
    brojFiskalnihKasa?: number;
    newPasswordHash?: string;
    pib?: string;
    mb?: string;

    constructor(data?: IRegisterCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.podaciKorisnika = _data["podaciKorisnika"] ? PodaciKorisnikaDto.fromJS(_data["podaciKorisnika"]) : <any>undefined;
            this.confirmationCode = _data["confirmationCode"];
            this.brojFiskalnihKasa = _data["brojFiskalnihKasa"];
            this.newPasswordHash = _data["newPasswordHash"];
            this.pib = _data["pib"];
            this.mb = _data["mb"];
        }
    }

    static fromJS(data: any): RegisterCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["podaciKorisnika"] = this.podaciKorisnika ? this.podaciKorisnika.toJSON() : <any>undefined;
        data["confirmationCode"] = this.confirmationCode;
        data["brojFiskalnihKasa"] = this.brojFiskalnihKasa;
        data["newPasswordHash"] = this.newPasswordHash;
        data["pib"] = this.pib;
        data["mb"] = this.mb;
        return data;
    }
}

export interface IRegisterCommand {
    podaciKorisnika?: PodaciKorisnikaDto;
    confirmationCode?: string;
    brojFiskalnihKasa?: number;
    newPasswordHash?: string;
    pib?: string;
    mb?: string;
}

export class PodaciKorisnikaDto implements IPodaciKorisnikaDto {
    ime?: string | undefined;
    prezime?: string | undefined;
    mobilniDto?: MobilniTelefonDto | undefined;
    email?: string | undefined;
    sifra?: string | undefined;
    sifraRepeat?: string | undefined;

    constructor(data?: IPodaciKorisnikaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ime = _data["ime"];
            this.prezime = _data["prezime"];
            this.mobilniDto = _data["mobilniDto"] ? MobilniTelefonDto.fromJS(_data["mobilniDto"]) : <any>undefined;
            this.email = _data["email"];
            this.sifra = _data["sifra"];
            this.sifraRepeat = _data["sifraRepeat"];
        }
    }

    static fromJS(data: any): PodaciKorisnikaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PodaciKorisnikaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ime"] = this.ime;
        data["prezime"] = this.prezime;
        data["mobilniDto"] = this.mobilniDto ? this.mobilniDto.toJSON() : <any>undefined;
        data["email"] = this.email;
        data["sifra"] = this.sifra;
        data["sifraRepeat"] = this.sifraRepeat;
        return data;
    }
}

export interface IPodaciKorisnikaDto {
    ime?: string | undefined;
    prezime?: string | undefined;
    mobilniDto?: MobilniTelefonDto | undefined;
    email?: string | undefined;
    sifra?: string | undefined;
    sifraRepeat?: string | undefined;
}

export class MobilniTelefonDto implements IMobilniTelefonDto {
    pozivniBroj?: string | undefined;
    brojTelefona?: string | undefined;
    getMobilniTelefon?: string | undefined;

    constructor(data?: IMobilniTelefonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pozivniBroj = _data["pozivniBroj"];
            this.brojTelefona = _data["brojTelefona"];
            this.getMobilniTelefon = _data["getMobilniTelefon"];
        }
    }

    static fromJS(data: any): MobilniTelefonDto {
        data = typeof data === 'object' ? data : {};
        let result = new MobilniTelefonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pozivniBroj"] = this.pozivniBroj;
        data["brojTelefona"] = this.brojTelefona;
        data["getMobilniTelefon"] = this.getMobilniTelefon;
        return data;
    }
}

export interface IMobilniTelefonDto {
    pozivniBroj?: string | undefined;
    brojTelefona?: string | undefined;
    getMobilniTelefon?: string | undefined;
}

export class ResultOfFiskalnaTokenResponse extends Result implements IResultOfFiskalnaTokenResponse {
    data?: FiskalnaTokenResponse | undefined;

    constructor(data?: IResultOfFiskalnaTokenResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? FiskalnaTokenResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultOfFiskalnaTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfFiskalnaTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IResultOfFiskalnaTokenResponse extends IResult {
    data?: FiskalnaTokenResponse | undefined;
}

export class FiskalnaTokenResponse implements IFiskalnaTokenResponse {
    token?: string | undefined;
    refreshToken?: string | undefined;
    refreshTokenExpiryTime?: Date;
    naziv?: string | undefined;
    tenantKey?: string | undefined;

    constructor(data?: IFiskalnaTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpiryTime = _data["refreshTokenExpiryTime"] ? new Date(_data["refreshTokenExpiryTime"].toString()) : <any>undefined;
            this.naziv = _data["naziv"];
            this.tenantKey = _data["tenantKey"];
        }
    }

    static fromJS(data: any): FiskalnaTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FiskalnaTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpiryTime"] = this.refreshTokenExpiryTime ? this.refreshTokenExpiryTime.toISOString() : <any>undefined;
        data["naziv"] = this.naziv;
        data["tenantKey"] = this.tenantKey;
        return data;
    }
}

export interface IFiskalnaTokenResponse {
    token?: string | undefined;
    refreshToken?: string | undefined;
    refreshTokenExpiryTime?: Date;
    naziv?: string | undefined;
    tenantKey?: string | undefined;
}

export class FiskalnaLoginRequest implements IFiskalnaLoginRequest {
    email?: string | undefined;
    password?: string | undefined;
    deviceToken?: string | undefined;

    constructor(data?: IFiskalnaLoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
            this.deviceToken = _data["deviceToken"];
        }
    }

    static fromJS(data: any): FiskalnaLoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FiskalnaLoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["deviceToken"] = this.deviceToken;
        return data;
    }
}

export interface IFiskalnaLoginRequest {
    email?: string | undefined;
    password?: string | undefined;
    deviceToken?: string | undefined;
}

export class FiskalnaRefreshTokenRequest implements IFiskalnaRefreshTokenRequest {
    token?: string | undefined;
    refreshToken?: string | undefined;

    constructor(data?: IFiskalnaRefreshTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): FiskalnaRefreshTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FiskalnaRefreshTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IFiskalnaRefreshTokenRequest {
    token?: string | undefined;
    refreshToken?: string | undefined;
}

export class FiskalnaRefreshDeviceTokenRequest implements IFiskalnaRefreshDeviceTokenRequest {
    token?: string | undefined;
    deviceToken?: string | undefined;

    constructor(data?: IFiskalnaRefreshDeviceTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.deviceToken = _data["deviceToken"];
        }
    }

    static fromJS(data: any): FiskalnaRefreshDeviceTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FiskalnaRefreshDeviceTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["deviceToken"] = this.deviceToken;
        return data;
    }
}

export interface IFiskalnaRefreshDeviceTokenRequest {
    token?: string | undefined;
    deviceToken?: string | undefined;
}

export class SendConfirmationCodeMojaFirmaCommand implements ISendConfirmationCodeMojaFirmaCommand {
    verifyVia?: UserAccessVia;
    korisnikEmail?: string | undefined;
    ime?: string | undefined;
    mobilniTelefonDto?: MobilniTelefonDto | undefined;

    constructor(data?: ISendConfirmationCodeMojaFirmaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verifyVia = _data["verifyVia"];
            this.korisnikEmail = _data["korisnikEmail"];
            this.ime = _data["ime"];
            this.mobilniTelefonDto = _data["mobilniTelefonDto"] ? MobilniTelefonDto.fromJS(_data["mobilniTelefonDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SendConfirmationCodeMojaFirmaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendConfirmationCodeMojaFirmaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verifyVia"] = this.verifyVia;
        data["korisnikEmail"] = this.korisnikEmail;
        data["ime"] = this.ime;
        data["mobilniTelefonDto"] = this.mobilniTelefonDto ? this.mobilniTelefonDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISendConfirmationCodeMojaFirmaCommand {
    verifyVia?: UserAccessVia;
    korisnikEmail?: string | undefined;
    ime?: string | undefined;
    mobilniTelefonDto?: MobilniTelefonDto | undefined;
}

export enum UserAccessVia {
    EMAIL = 0,
    MOBILE = 1,
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}